import Image from 'next/image';

import TopSection from 'react-scale/components/pages/careers/TopSection';
import Departments from 'react-scale/components/pages/careers/Departments';

const Hero = () => (
  <div>
    <TopSection
      title="Scale is growing. <br /> Grow with us."
      subtitle="Join us as we accelerate the development of AI applications."
    />
    <div className="relative">
      <div className="relative w-full h-full mx-auto" style={{ maxWidth: 1440 }}>
        <Image
          src="/static/images/pages/careers/scale-team.jpg"
          alt="the amazing Scale Team!"
          width={1440}
          height={648}
          quality="100"
          unoptimized
        />
      </div>
      <div className="container relative z-10 -mt-[84px]">
        <Departments />
      </div>
    </div>
  </div>
);

export default Hero;
